import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../style';
import { prefixObjectValues, getHtmlFromMarkdown } from '../../utils';
import useHandlebars from '../../hooks/use-handlebars';
import { FormContext } from '../../contexts/form-context';

interface NextStepProps {
  keyId?: string;
  title?: string;
  description?: string;
  thumbnail?: any;
  link?: any;
  type?: string;
}

const domIdsStatic = {
  rootNode: 'next-step',
};

export const domIdsUnique = (prefix?: string) =>
  prefixObjectValues(prefix, domIdsStatic);

const Container = styled.div`
  background-color: ${colors.coolNeutralL1};
`;

const NextStep: (p: NextStepProps) => React.ReactElement = (p) => {
  const [shown, setShown] = useState(false);
  const domIds = domIdsUnique(p.keyId);
  const { formContext } = React.useContext(FormContext);
  const markdown = useHandlebars(p.description, formContext);
  let externalLink;
  let linkUrl;
  if (p?.link?.linkedItems?.length > 0) {
    externalLink =
      p.link.linkedItems[0].elements.is_client_route_.value[0].codename ===
      'no';
    linkUrl = p.link.linkedItems[0].elements.url.value;
  }
  const compiledLink = useHandlebars(linkUrl, formContext);

  const handleNextStepClick = (_e: any) => {
    // Click handler
  };

  React.useEffect(() => {
    if (
      p.title !== undefined &&
      p.title.split(' ').includes('Fig') &&
      shown === false
    ) {
      setShown(true);
    }
  }, [p, shown, formContext]);

  return (
    <Container id={domIds.rootNode}>
      {!externalLink ? (
        <Link to={compiledLink} className="next-step-box">
          <img alt="" src={p.thumbnail} />
          <span className="next-content">
            <span className="next-title">{p.title}</span>
            <span
              dangerouslySetInnerHTML={
                p.description ? getHtmlFromMarkdown(markdown) : undefined
              }
            ></span>
          </span>
        </Link>
      ) : (
        <a
          href={compiledLink}
          target={p.link?.linkedItems?.[0]?.elements?.target?.value}
          className="next-step-box"
          rel="noreferrer"
          onClick={(e) => handleNextStepClick(e)}
        >
          <img alt="" src={p.thumbnail} />
          <span className="next-content">
            <span className="next-title">{p.title}</span>
            <span
              className="next-copy"
              dangerouslySetInnerHTML={
                p.description ? getHtmlFromMarkdown(markdown) : undefined
              }
            ></span>
          </span>
        </a>
      )}
    </Container>
  );
};

export default NextStep;
